import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Edit, Trash2 } from 'lucide-react';
import './Etiquetas.css';

const Etiquetas = () => {
    const [etiquetas, setEtiquetas] = useState([]);
    const [etiqueta, setEtiqueta] = useState({ nome: '' });
    const [editing, setEditing] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    useEffect(() => {
        fetchEtiquetas();
    }, []);

    const fetchEtiquetas = async () => {
        try {
            const response = await api.get('/etiquetas');
            setEtiquetas(response.data);
        } catch (error) {
            console.error("Erro ao buscar etiquetas", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEtiqueta({ ...etiqueta, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (editing) {
            try {
                await api.put(`/etiquetas/${currentId}`, etiqueta);
                setEditing(false);
                setCurrentId(null);
            } catch (error) {
                console.error("Erro ao atualizar etiqueta", error);
            }
        } else {
            try {
                await api.post('/etiquetas', etiqueta);
            } catch (error) {
                console.error("Erro ao criar etiqueta", error);
            }
        }
        setEtiqueta({ nome: '' });
        fetchEtiquetas();
    };

    const handleEdit = (etiqueta) => {
        setEditing(true);
        setCurrentId(etiqueta.id);
        setEtiqueta({ nome: etiqueta.nome });
    };

    const handleDelete = async (id) => {
        try {
            await api.delete(`/etiquetas/${id}`);
            fetchEtiquetas();
        } catch (error) {
            console.error("Erro ao deletar etiqueta", error);
        }
    };

    const handleCancel = () => {
        setEditing(false);
        setCurrentId(null);
        setEtiqueta({ nome: '' });
    };

    return (
        <div className="etiquetas-container">
            <h1>Gerenciar Etiquetas</h1>
            <form onSubmit={handleSubmit} className="etiqueta-form">
                <input
                    type="text"
                    name="nome"
                    value={etiqueta.nome}
                    onChange={handleInputChange}
                    placeholder="Nome da Etiqueta"
                    required
                />
                <button type="submit">{editing ? 'Atualizar' : 'Criar'}</button>
                {editing && <button type="button" onClick={handleCancel}>Cancelar</button>}
            </form>
            <ul className="etiquetas-list">
                {etiquetas.map((et) => (
                    <li key={et.id}>
                        <span>{et.nome}</span>
                        <div>
                            <button onClick={() => handleEdit(et)} className="icon-button"><Edit size={20} /></button>
                            <button onClick={() => handleDelete(et.id)} className="icon-button"><Trash2 size={20} /></button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Etiquetas;
